import { Component, OnInit, ViewChild, Input,Inject,OnDestroy } from '@angular/core';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { ResidentByID, getResidentbyid, residentrelease, Residentreleasetype, ResidentMedicalHistorydetails } from './resident';
import { ResidentService } from './resident.service';
import { HomeService } from '../home/home.service';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import {appsettings} from '../../app-settings';
import { AddResidentComponent } from './add-resident/add-resident.component';
import { EditResidentComponent } from './edit-resident/edit-resident.component';
import { ReleaseResidentComponent } from './release-resident/release-resident.component';
import { MedicalHistoryComponent } from './medical-history/medical-history.component';
import { DownloadResidentComponent } from './download-resident/download-resident.component';
import { showResidentGroupComponent } from './show-resident-group/show-resident-group.component';
import { MainLayoutService } from '../../main-layout/main-layout.service';
import { Resident_Status, enumResidentStatus, enumgetResidentData, enumUIFeatureView, enumUIAction, enumUIView,enumChronoLogical } from '../../app-settings';
import { SidenavComponent } from '../../main-layout/sidenav/sidenav.component';
import { InfrastructureAlertsComponent } from '../../main-layout/alerts/infrastructure-alerts/infrastructure-alerts.component';
import { ApiService } from '../../api.service';
import { SharedCheckIsAlertReportData,Resident, MapSyncProcess,getResidentRequest } from '../../api';
import { AlertSharedService } from '../../_services/index';
import { RollbarService } from '../../rollbar';
import * as Rollbar from 'rollbar';
import { Http } from '@angular/http';
import { SessionCheckwithStaff,checkStaffData, getFeatureNeedtoShow, getAddEditDeleteColumn, AuthFailedMessage, generateAlertMessage } from '../../app-general';
import {Router} from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';
export interface ResidentStatus
{
  Name: string;
  Value: string;
}

@Component({
  selector: 'app-resident',
  templateUrl: './resident.component.html',
  providers: [ ResidentService ],
  styleUrls: ['./resident.component.scss']
})
export class ResidentComponent implements OnInit,OnDestroy {

  Residents: Resident[];
  smcurrentScreenWidth: string = 'sm';
  xscurrentScreenWidth: string = 'xs';
  dialogResult = "";
  Residentbyid: getResidentbyid[];
  displayedColumns: string[] = ['PhotoID', 'Name', 'UnitName', 'TagID', 'RoomNumber','Status','isWanderMode','medicalhistory', 'edit', 'delete'];
  IsRefreshNeed = 1;
  
  dataSource;
  downloadResidentSource;
  dataSourcecount;
  Release: number = Residentreleasetype.Release;
  Reallocate: number = Residentreleasetype.Reallocate;
  getResidentbyID;
  bGroupView:boolean=false;
  bAddEdit:boolean=false;
  bDelete:boolean=false;
  bRoamingEdit:boolean=false;
  filteredArray: any[] = [];
  chksearchvalue;
  chkResidentStatus;
  public residentStatus = Resident_Status;
  public EnumResidentStatus = enumResidentStatus;
  ressortedData = [];
  residentstatus;
  resloading = true;
  residentList;
  SiteId = "1";
  statusdata = "Release";
  Residentlength;
  checkliveresidentdata;
  res_MapSyncProcess;
  interval_resident;
  @Input() 
  residentImgUrl:string = appsettings.RESIDENT_FOLDER;
  private _onDestroy: Subject<void> = new Subject<void>();
  constructor(private router: Router,private residentService: ResidentService,@Inject(RollbarService) private rollbar: Rollbar,private mediaObserver: MediaObserver,public dialog: MatDialog,
  public mainLayoutService: MainLayoutService,private apiService: ApiService,private alertSharedService: AlertSharedService,private http:Http,private homeService: HomeService) {

    mediaObserver.media$.subscribe((change: MediaChange) => {
     if (getFeatureNeedtoShow(enumUIFeatureView.Resident, enumUIAction.Resident_AddEditDelete) == enumUIView.Show) {
        this.bAddEdit = true;
        this.bDelete = true;
      }
     
      if (getFeatureNeedtoShow(enumUIFeatureView.Roaming, enumUIAction.Roaming_View) == enumUIView.Show) {
        this.bRoamingEdit = true;
      }
     
      
      if (getFeatureNeedtoShow(enumUIFeatureView.Resident_Group, enumUIAction.Resident_Group_View) == enumUIView.Show) {
        this.bGroupView = true;
      }
          if (change.mqAlias == this.xscurrentScreenWidth) {
              this.setupTableforXtrasmallerwidth();
          }
          else if (change.mqAlias == this.smcurrentScreenWidth) {
              this.setupTableforsmallerwidth();
          }
           else
          {
            this.setupFullTable();
          }

      });

}

@ViewChild(MatSort) sort: MatSort;
@ViewChild(MatPaginator) paginator: MatPaginator;

ngOnInit() {
  if (getFeatureNeedtoShow(enumUIFeatureView.Resident, enumUIAction.Resident_View) != enumUIView.Show) {
    localStorage.clear();
    this.router.navigate(['/login']);
  }
  if (getFeatureNeedtoShow(enumUIFeatureView.Resident, enumUIAction.Resident_AddEditDelete) == enumUIView.Show) {
    this.bAddEdit = true;
    this.bDelete = true;
  }
  
  
  if (this.IsRefreshNeed == 1) {
    var ChkIsAlertReportChanged = true;

    this.alertSharedService.currentSharedCheckIsAlertReport().pipe(takeUntil(this._onDestroy)).subscribe((SharedCheckIsAlertReportDetails: SharedCheckIsAlertReportData) => {
      var CheckIsAlertReportDataChanged = SharedCheckIsAlertReportDetails;
      if (CheckIsAlertReportDataChanged != undefined) {
        if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 1 && ChkIsAlertReportChanged) {
          ChkIsAlertReportChanged = false;
          
          setTimeout(() => {
            
            var liveItem = { SiteId: this.SiteId, AuthKey: localStorage.getItem("Authkey") }
            this.readLiveData(liveItem);
            if (this.chkResidentStatus == undefined)
              this.residentstatus = enumResidentStatus.Current;
            else
              this.residentstatus = this.chkResidentStatus;
            this.getResidentData();
          }, (1000 * 60 * 1));

          CheckIsAlertReportDataChanged.IsAlertReportChanged = 0;
          this.alertSharedService.changeSharedCheckIsAlertReport(CheckIsAlertReportDataChanged);
        }
        else if (CheckIsAlertReportDataChanged.IsAlertReportChanged == 0) {
          ChkIsAlertReportChanged = true;
        }
      }
    });
  }

  var liveItem = { SiteId: this.SiteId, AuthKey: localStorage.getItem("Authkey") }
  this.readLiveData(liveItem);
  this.residentstatus = enumResidentStatus.Current;
  this.getResidentData();  



  this.getStaffById();         
}

  readLiveData(LiveItem) {
      this.viewRoomData();
  }

  viewRoomData() {
    var sReturn=getFeatureNeedtoShow(enumUIFeatureView.Location, enumUIAction.Location_RTLS_Resident);
    if (sReturn.toString()==enumUIView.Show.toString() )
    {
      this.checkliveresidentdata='1';
    }
    else
    {
      this.checkliveresidentdata='0';
    }
     
      var RoomIndex = this.displayedColumns.indexOf('RoomName');
      if (this.checkliveresidentdata != undefined) {
        if (this.checkliveresidentdata != '1') {
          if (RoomIndex >= 0) {
            this.displayedColumns.splice(RoomIndex, 1);
          }
        }
      }
    
  }

getStaffById()
{  
  checkStaffData(this.apiService,this.alertSharedService);    
}

setupTableforXtrasmallerwidth() {
    this.displayedColumns = ['Name', 'TagId', 'RoomName', 'Status', 'edit', 'delete'];
    this.viewRoomData();
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
    
};

setupTableforsmallerwidth() {
  this.displayedColumns = ['photo','Name', 'TagId', 'RoomName', 'Status', 'edit', 'delete'];
  this.viewRoomData();
  this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
  
};

setupFullTable() {
    this.displayedColumns = ['photo', 'Name','UnitName', 'TagId',  'RoomName', 'Status', 'isWanderMode','medicalhistory', 'edit', 'delete'];
    this.viewRoomData();
    this.displayedColumns = getAddEditDeleteColumn(this.displayedColumns,this.bAddEdit,this.bDelete);
  
};

getResidentData(): void {
 try
 {
   
  this.resloading = true;  
  let residentdata : getResidentRequest = 
  {    
    authKey: localStorage.getItem("Authkey"), 
    residentType: enumgetResidentData.AllData,
    isChronoLogical:enumChronoLogical.chronoLogical 
  }; 
   this.apiService.getResidentData(residentdata).pipe(takeUntil(this._onDestroy))
    .subscribe((Residents : any[])=>{       
      if(Residents["apiReturn"] == "Invalid Auth Key")
      {                  
          AuthFailedMessage(this.dialog,this.router); 
          return;        
      }     
      this.resloading = false
      this.Residents = Residents["apiReturn"];
      if(this.Residents.length >0 )
        this.Residentlength = Residents["apiReturn"][0].MaxId;
      else
      this.Residentlength =0;
    
      this.dataSource = new MatTableDataSource(this.Residents); 
      this.downloadResidentSource = new MatTableDataSource(this.Residents); 
      this.downloadResidentSource.data = this.Residents; 
  
      if(this.chksearchvalue == undefined && this.chkResidentStatus == undefined)                  
      {
        this.residentList = this.Residents.filter(function(e){
            return e.Status == 1;
        });
        this.dataSource.data = this.residentList;
        this.downloadResidentSource.data = this.residentList;
       // this.dataSource.data = this.Residents; 
      }
      else if(this.chksearchvalue != undefined && this.chkResidentStatus == undefined)
      {
        this.searchResident(this.chksearchvalue);        
      }
      else if(this.chksearchvalue == undefined && this.chkResidentStatus != undefined)
      {
        this.selectresStatus(this.chkResidentStatus)
      }
      else if(this.chksearchvalue != undefined && this.chkResidentStatus != undefined)
      {
        this.searchResident(this.chksearchvalue);
        this.selectresStatus(this.chkResidentStatus)
      }
      setTimeout(() => { 
        this.ressortedData = [];
        this.dataSource.sort = this.sort;
        this.sortingDatalist(this.dataSource);  
        this.downloadResidentSource.sort = this.sort; 
        this.sortingDatalist(this.downloadResidentSource);   
        this.downloadResidentSource.connect().subscribe(data => this.ressortedData = data);            
     }, 0);
         
      this.dataSource.paginator = this.paginator;         
      if(this.chksearchvalue == undefined)
          this.dataSourcecount= this.dataSource.data.length;  
      else
          this.dataSourcecount= this.dataSource.filteredData.length;   
        
    });    
  }
  catch (err) {
    throw new Error('resident.component.ts' + ' - getResidentData() - ' + err.message);
  }
}

Residentstatus:ResidentStatus[] = [
  {Name: 'All', Value: "All"},  
  {Name: 'Current', Value: "Current"},
  {Name: 'Deceased', Value: "Deceased"},
  {Name: 'Released', Value: "Released"},
];

searchResident(filterValue: string) {  
  if (filterValue !=null)
  {
    
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches    
    this.chksearchvalue = filterValue;
    this.dataSource.filter = filterValue;        

    this.selectresStatus(this.residentstatus);
    this.searchfilter();    
      
    
    
     if(this.chkResidentStatus == "All")
    {
      this.dataSource.data = this.Residents;    
      this.dataSourcecount = this.dataSource.filteredData.length;    
    }
    else
    {
        this.dataSource.data = this.filteredArray;        
        this.dataSourcecount = this.dataSource.filteredData.length;    
    }  
  }     
}
searchfilter()
{
  this.dataSource.filterPredicate = function(data, filter: string): boolean {
    var filtersearch=filter.toLowerCase();
    //var ResidentName= data.Name + data.TagId + data.SpouseName + data.GroupName + data.RoomName;
    //return ResidentName.toLowerCase().includes(filter);
   return data.Name.toLowerCase().includes(filtersearch) || data.UnitName.toLowerCase().includes(filtersearch) || data.TagId.toString().includes(filtersearch) || 
          data.RoomName.toLowerCase().includes(filtersearch); 
  }; 
}

selectresStatus(ResidentStatus: string)
  {    
    this.dataSource.data = this.Residents;
    this.filteredArray = [];    
    var Residentstatus = "";    
    if(ResidentStatus == enumResidentStatus.Current)
    { 
      Residentstatus = "1";
      this.statusdata = "Release"
    }       
    else if(ResidentStatus == enumResidentStatus.Deceased)
    {
       Residentstatus = "2";
       this.statusdata = "Restore"
    }       
    else if(ResidentStatus == enumResidentStatus.Released)
    {
      Residentstatus = "3";
      this.statusdata = "Restore"
    }
            

    this.chkResidentStatus = ResidentStatus;

      var list = this.dataSource.data.filter(x => x.Status == Residentstatus);
      list.forEach(x => {        
        this.filteredArray.push(x);
      })

    if(ResidentStatus == "All")
    {  
      this.statusdata = "Release/Restore"
      this.dataSource.data = this.Residents;        
     this.downloadResidentSource.data = this.dataSource.data;       
      setTimeout(() => {         
        this.dataSource.sort = this.sort;  
        this.sortingDatalist(this.dataSource);        
        this.downloadResidentSource.sort = this.sort;  
        this.sortingDatalist(this.downloadResidentSource);        
        this.downloadResidentSource.connect().subscribe(data => this.ressortedData = data);            
     }, 0);      
     if(!this.chksearchvalue)
        this.dataSourcecount= this.dataSource.data.length;
      else
        this.dataSourcecount = this.dataSource.filteredData.length;
    }      
    else
    {          
      this.dataSource.data = this.filteredArray;    
      this.downloadResidentSource.data = this.filteredArray;     
      if(!this.chksearchvalue)
        this.dataSourcecount= this.dataSource.data.length;
      else
        this.dataSourcecount = this.dataSource.filteredData.length;
       
        setTimeout(() => {           
          this.dataSource.sort = this.sort;
          this.sortingDatalist(this.dataSource);          
          this.downloadResidentSource.sort = this.sort;  
          this.sortingDatalist(this.downloadResidentSource);          
          this.downloadResidentSource.connect().subscribe(data => this.ressortedData = data);                    
       }, 0);         

    }    
  }

/*********Opendialogwindow*******/
addResidentdata() { 
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  let residentlistelement = document.getElementById('divresidentdetails');
      residentlistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.res_MapSyncProcess = MapSyncinfo  
    if(this.res_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let devicelistelement = document.getElementById('divresidentdetails');
          devicelistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      var resAddComponentHeight;
      const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);             
      if(isIEOrEdge == true)
      {       
          resAddComponentHeight = '780px';
      }   
      else
      {
          resAddComponentHeight = '760px';
      }
      let dialogRef = this.dialog.open(AddResidentComponent, {
        disableClose: true,
        width: '1050px',
        height: resAddComponentHeight,
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data:this.Residentlength
      });

      dialogRef.afterClosed().subscribe(result => {   
        let residentlistelement = document.getElementById('divresidentdetails');
            residentlistelement.className = 'clsenable';   
        if(result == 'Confirm')
        {
          let element = document.getElementById('btnresdata');
          element.className = 'clsresidentbutton mat-raised-button mat-primary ng-star-inserted';      
          this.getResidentData();     
        } 
        else
        {
          let element = document.getElementById('btnresdata');
          element.className = 'clsresidentbutton mat-raised-button mat-primary ng-star-inserted';           
        }
      })
    }
  })
}

editResidentdata(residentId : number) 
{ 

  let residentlistelement = document.getElementById('divresidentdetails');
      residentlistelement.className = 'clsdisable';
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.res_MapSyncProcess = MapSyncinfo  
    if(this.res_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let devicelistelement = document.getElementById('divresidentdetails');
          devicelistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let residentlistelement = document.getElementById('divresidentdetails');
          residentlistelement.className = 'clsdisable';
      if(!SessionCheckwithStaff(this.router))
      {
          return;
      }

      
      let residentbyid: ResidentByID = {        
        authKey: localStorage.getItem("Authkey"),
        residentId : residentId
      }

      this.residentService.getResidentDataById(residentbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((ResidentbyId : any[])=>{    
        this.Residentbyid = ResidentbyId["apiReturn"]; 
          this.editopendialog(this.Residentbyid)
      });  
    }
})
 
}

editopendialog(Residentbyid){ 
    var resEditComponentHeight;
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);  
    if(isIEOrEdge == true)
    {       
        resEditComponentHeight = '780px';
    }   
    else
    {
        resEditComponentHeight = '760px';
    }
    let dialogRef = this.dialog.open(EditResidentComponent, {    
      disableClose: true,
      width: '1050px',
      height: resEditComponentHeight,
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: Residentbyid    
    });    
    dialogRef.afterClosed().subscribe(result => {   
      let residentlistelement = document.getElementById('divresidentdetails');
          residentlistelement.className = 'clsenable';
      if(result == 'Confirm')
      {        
        this.getResidentData();    
      }   
                  
    }) 
  
}

releaseResidentdata(residentId : number, Type : number) { 

  let residentlistelement = document.getElementById('divresidentdetails');
      residentlistelement.className = 'clsdisable';
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }
  var _dialog = this.dialog;
  let mapsyncinfo : MapSyncProcess = 
  {
    siteId:this.SiteId,
    authKey: localStorage.getItem("Authkey")
  };
  this.apiService.checkMapSync(mapsyncinfo).pipe(takeUntil(this._onDestroy))
  .subscribe((MapSyncinfo: any[]) => { 
    this.res_MapSyncProcess = MapSyncinfo  
    if(this.res_MapSyncProcess == 1)
    {
      generateAlertMessage(_dialog, appsettings.MapSyncMsg); 
      let devicelistelement = document.getElementById('divresidentdetails');
          devicelistelement.className = 'clsenable';            
      return false;
    }     
    else
    {
      let residentbyid: ResidentByID = {        
        authKey: localStorage.getItem("Authkey"),
        residentId : residentId
      }

      this.residentService.getResidentDataById(residentbyid).pipe(takeUntil(this._onDestroy))
      .subscribe((ResidentbyId : any[])=>{  
        if(ResidentbyId["apiReturn"] == "Invalid Auth Key")
        {                  
            AuthFailedMessage(this.dialog,this.router);  
            return;       
        } 
        this.Residentbyid = ResidentbyId["apiReturn"];   
      if(Type == this.Release)
        {
          this.releaseopendialog(this.Residentbyid,this.Release)
        }
      else if(Type == this.Reallocate)
        {
          this.reallocateResidentdata(this.Residentbyid,this.Reallocate)
        }
      });    
    }
  })
 
}

releaseopendialog(Residentbyid,Type) {  
    let releaseResidentdata : residentrelease ={
        ResidentbyId : Residentbyid,
        Reltype : Type
    }
    let dialogRef = this.dialog.open(ReleaseResidentComponent, {
      disableClose: true,
      width: '550px',
      height:'460px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: releaseResidentdata
    });
    dialogRef.afterClosed().subscribe(result => {    
      let residentlistelement = document.getElementById('divresidentdetails');
          residentlistelement.className = 'clsenable';
      if(result == 'Confirm')
      {
        this.getResidentData();  
      }         
    })
}

reallocateResidentdata(ResidentbyId,Type) {  
    let residentlistelement = document.getElementById('divresidentdetails');
        residentlistelement.className = 'clsdisable';
    let releaseResidentdata : residentrelease ={
      ResidentbyId : ResidentbyId,
      Reltype : Type
    }
    let dialogRef = this.dialog.open(ReleaseResidentComponent, {
      disableClose: true,
      width: '500px',
      height:'300px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: releaseResidentdata
    });    
    dialogRef.afterClosed().subscribe(result => {      
      let residentlistelement = document.getElementById('divresidentdetails');
          residentlistelement.className = 'clsenable'; 
      if(result == 'Confirm')
      {       
        this.getResidentData();  
      }              
    })

}

getMedicalHistory(Residentbyid : number){
  let residentlistelement = document.getElementById('divresidentdetails');
      residentlistelement.className = 'clsdisable';
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }

  this.getResidentbyID = Residentbyid;
  let residentbyid: ResidentByID = {    
    authKey: localStorage.getItem("Authkey"),
    residentId : Residentbyid
  }
  this.residentService.getMedicalHistory(residentbyid).pipe(takeUntil(this._onDestroy))
  .subscribe((ResidentbyId : any[])=>{  
    if(ResidentbyId["apiReturn"] == "Invalid Auth Key")
    {                  
        AuthFailedMessage(this.dialog,this.router);  
        return;       
    }     
    this.Residentbyid = ResidentbyId["apiReturn"];   
    this.medicalhistoryopendialog(this.Residentbyid)
  });   
  
}

medicalhistoryopendialog(ResidentMedhistorybyid){      
    if(ResidentMedhistorybyid == "")
    {
      let residentmedhistory :  ResidentMedicalHistorydetails = {
        ResidentId: this.getResidentbyID,
        AddType : 1
      }    
      ResidentMedhistorybyid = residentmedhistory;
    }    
    let dialogRef = this.dialog.open(MedicalHistoryComponent, {
      disableClose: true,
      width: '980px',
      height:'640px',
      panelClass: 'myapp-no-padding-dialog',
      autoFocus: false,
      data: ResidentMedhistorybyid
      
    });   
    dialogRef.afterClosed().subscribe(result => {    
      let residentlistelement = document.getElementById('divresidentdetails');
          residentlistelement.className = 'clsenable';                    
      if(result == 'Confirm')
      {        
        this.getResidentData();  
      }      
    })  
}

downloadResidentdata()
{  
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }    
  if(this.dataSource.filter != '')
  {
    this.downloadResidentSource.data = this.dataSource.filteredData;
    setTimeout(() => {        
      this.dataSource.sort = this.sort; 
      //this.downloadResidentSource.sort = this.sort;         
      this.downloadResidentSource.connect().subscribe(data => this.ressortedData = data);   
   }, 0);      
  }    
 
  var residentdata = this.ressortedData; 
  const dialogRef = this.dialog.open(DownloadResidentComponent, {
    disableClose: true,
    width: '388px',
    height: '165px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
    data: residentdata
  });
  dialogRef.afterClosed().subscribe(result => {
    let element1 = document.getElementById('downloadresdata');
    element1.className = 'clsresidentbutton mat-raised-button mat-primary ng-star-inserted'; 
  });
}

/*********Open Resident group dialogwindow*******/
ClickResidentGroup() { 
  if(!SessionCheckwithStaff(this.router))
  {
      return;
  }

  let dialogRef = this.dialog.open(showResidentGroupComponent, {
    disableClose: true,
    width: '700px',
    height:'400px',
    panelClass: 'myapp-no-padding-dialog',
    autoFocus: false,
  });

  dialogRef.afterClosed().subscribe(result => {    
    if(result == 'Cancel')
    {
      let element2= document.getElementById('btnresgroup');
      element2.className = 'clsaddgroup mat-raised-button mat-primary ng-star-inserted';          
    }     
    else
    {
      let element2= document.getElementById('btnresgroup');
      element2.className = 'clsaddgroup mat-raised-button mat-primary ng-star-inserted';    
      this.getResidentData();  
    }
  })
}
sortingDatalist(DataSource)
{
  DataSource.sortingDataAccessor = function(data, sortHeaderId: string) {               
      if(sortHeaderId != 'TagId')
      {               
        return data[sortHeaderId].toString().toLocaleLowerCase().trim('');                
      }   
      else
      {                
        return data[sortHeaderId]; 
      }                                    
  }
}
CloseRightNav(){     
  if(SidenavComponent.isClosed == false)
  {
      this.mainLayoutService.toggleSideNavRight.emit();
  }
  if(InfrastructureAlertsComponent.isinfraClosed == false)
  {
      this.mainLayoutService.toggleinfrastructureLeft.emit("close");
  }
}
 
ngOnDestroy() {
  clearInterval(this.interval_resident);
	this._onDestroy.next();
	this._onDestroy.complete();
}
}
